import React from 'react'
import { format } from '@e3dc-react/shell/Libs/date'
import { ApiTableColumn, FetchProps } from '@e3dc-react/shell/Elements/ApiView'
import InstallationLink from 'src/Elements/Installations/InstallationLink'
import {
  InstallationStatementButton,
  InstallationStatementButtonMobile,
} from 'src/Libs/installation-statement/components/InstallationStatementButton'
import { Statement } from 'src/Libs/installations/types'
import { InstallationMissingIbnTableColumnsResult, InstallationMissingIbnTableColumns } from '../hooks'
import { IbnDeadline, MissingIbnInstallationLinkMobile, MissingIbnInstallationType } from '../components'
import { TFunction } from 'i18next'
import { Stack } from '@mui/material'
import { isFlowTheme } from 'src/Libs/utils'

export const getMissingIbnInstallationsFetchProps = (filter: string): FetchProps => {
  return {
    url: 'installations/statements',
    endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    orderBy: '+ibnDeadlineAt',
    filter,
  }
}

export const getInstallationMissingIbnTableColumns = (t: TFunction): InstallationMissingIbnTableColumnsResult => {
  const tableColumnsSm: ApiTableColumn<InstallationMissingIbnTableColumns>[] = [
    {
      name: 'type',
      label: t('installation-statement.overviewTable.titleMobile'),
      value: (item: Statement) => {
        return <MissingIbnInstallationLinkMobile item={item} />
      },
      sortable: false,
    },
    {
      name: 'ibnDeadlineAt',
      label: t('installation-statement.overviewTable.ibnDeadlineAt'),
      value: ({ installationId, deviceLinkId, installationStatementId, deviceId, installer, installerCompanyId, ibnDeadlineAt }: Statement) => {
        return (
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <IbnDeadline ibnDeadlineAt={ibnDeadlineAt} />
            <InstallationStatementButtonMobile
              installation={{ id: installationId, deviceLinkId, installationStatementId, deviceId, installer, installerCompanyId }}
              disabled={isFlowTheme}
            />
          </Stack>
        )
      },
      sortable: true,
    },
  ]

  const tableColumnsMd: ApiTableColumn<InstallationMissingIbnTableColumns>[] = [
    {
      name: 'installationId',
      label: t('installation-statement.overviewTable.installationId'),
      value: ({ installationId, deviceId, partnersInstallationName }: Statement) => {
        return (
          <InstallationLink
            installation={{
              id: installationId,
              emsMasterDeviceId: deviceId,
              partnersInstallationName: partnersInstallationName,
              installationStatus: 'incomplete',
            }}
          />
        )
      },
      sortable: false,
    },
    {
      name: 'deviceId',
      label: t('installation-statement.overviewTable.deviceId'),
      value: (item: Statement) => {
        return item.deviceId
      },
      sortable: false,
    },
    {
      name: 'type',
      label: t('installation-statement.overviewTable.type'),
      value: (item: Statement) => {
        return <MissingIbnInstallationType item={item} />
      },
      sortable: false,
    },
    {
      name: 'owner',
      label: t('installation-statement.overviewTable.owner'),
      value: (item: Statement) => {
        return item.owner
      },
      sortable: false,
    },
    {
      name: 'commissioning',
      label: t('installation.overview.createdAt'),
      value: (item: Statement) => format(new Date(item.commissioning), t('common.format.date-fns-date')),
      sortable: false,
    },
    {
      name: 'installer',
      label: t('installation-statement.overviewTable.installer'),
      value: (item: Statement) => {
        return item.installer
      },
      sortable: false,
    },
    {
      name: 'ibnDeadlineAt',
      label: t('installation-statement.overviewTable.ibnDeadlineAt'),
      value: ({ ibnDeadlineAt }: Statement) => {
        return <IbnDeadline ibnDeadlineAt={ibnDeadlineAt} />
      },
      sortable: true,
    },
    {
      name: 'installationRequirements',
      label: t('framework.ibn'),
      value: ({ installationId, deviceLinkId, installationStatementId, deviceId, installer, installerCompanyId }: Statement) => {
        return (
          <InstallationStatementButton
            installation={{ id: installationId, deviceLinkId, installationStatementId, deviceId, installer, installerCompanyId }}
            disabled={isFlowTheme}
          />
        )
      },
      sortable: false,
    },
  ]

  return { tableColumnsMd, tableColumnsSm }
}
